import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { ref, watch } from 'vue';
export default {
  __name: 'BaseCheckBox',
  props: {
    checkBoxData: {
      type: Object,
      default: () => {}
    },
    defaultVal: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['processCheckBoxGroupData'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    let checkData = ref(null);
    watch(() => props.checkBoxData, newVal => {
      checkData.value = processPermissionDefaultData(newVal);
    }, {
      immediate: true
    });
    watch(() => props.defaultVal, newVal => {
      newVal && processPermissionDefaultVal(newVal);
    }, {
      immediate: true,
      deep: true
    }); // 编辑或者查看时处理默认填充数据

    function processPermissionDefaultVal(defaultVal) {
      let selectedIdArr = defaultVal.map(item => item.id);
      checkData.value.forEach(system => {
        selectedIdArr.forEach(id => {
          let selectedItem = system.checkboxGroup.filter(item => item.id === id);
          selectedItem.length && system.checked.push(selectedItem?.[0]?.series || selectedItem?.[0]?.name);
        });
        system.checkAll = system.checked.length && system.checked.length === system.checkboxGroup.length;
        system.indeterminate = system.checked.length && system.checked.length < system.checkboxGroup.length;
      });
    } // 将传入的选项数据处理成所需的结构


    function processPermissionDefaultData(data) {
      let permissionData = [];

      for (let system in data) {
        data[system]?.forEach(item => {
          item.check = false;
          item.name = item?.series || item?.name;
        });
        let systemCheck = {
          name: system,
          indeterminate: false,
          checkAll: false,
          checked: [],
          checkboxGroup: data[system]
        };
        permissionData.push(systemCheck);
      }

      return permissionData;
    } // 是否进行全选的事件方法


    function handleAllCheckboxChange(system) {
      system.checked = system.checkAll ? system.checkboxGroup.map(item => item.name) : [];
      system.indeterminate = false;
      processData();
    } // 选项是否勾选事件方法


    function handleModulesCheckboxChange(system) {
      system.indeterminate = system.checkboxGroup.length > system.checked.length && system.checked.length > 0;
      system.checkAll = system.checkboxGroup.length === system.checked.length;
      processData();
    } // 根据勾选选项处理数据，并将处理后的数据传递给父组件


    function processData() {
      let checkedIds = [];
      checkData.value.forEach(parent => {
        parent.checked.forEach(child => {
          let data = parent.checkboxGroup.filter(item => child === item.name);
          checkedIds.push(data[0].id);
        });
      });
      emit('processCheckBoxGroupData', checkedIds);
    }

    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkData), (system, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [_createVNode(_component_el_checkbox, {
          class: "system",
          indeterminate: Boolean(system.indeterminate),
          modelValue: system.checkAll,
          "onUpdate:modelValue": $event => system.checkAll = $event,
          disabled: props.disabled,
          onChange: $event => handleAllCheckboxChange(system),
          "validate-event": false
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(system.name), 1)]),
          _: 2
        }, 1032, ["indeterminate", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]), _createVNode(_component_el_checkbox_group, {
          class: "modules-group",
          modelValue: system.checked,
          "onUpdate:modelValue": $event => system.checked = $event,
          disabled: props.disabled,
          onChange: $event => handleModulesCheckboxChange(system, system)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.checkboxGroup, (item, key2) => {
            return _openBlock(), _createElementBlock("span", {
              class: "modules-item",
              key: key2
            }, [_createVNode(_component_el_checkbox, {
              label: item.name,
              modelValue: item.check,
              "onUpdate:modelValue": $event => item.check = $event
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["label", "modelValue", "onUpdate:modelValue"])]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])], 64);
      }), 128);
    };
  }

};